<template>
  <div
    class="lessons__status-confirmed_user"
    v-if="
      lessonStatusId === 2 ||
      lessonStatusId === 3 ||
      lessonStatusId === 4 ||
      lessonStatusId === 5
    "
  >
    <div class="lessons__status-confirmed_user-controls">
      <button
        v-if="status_confirmed_id === 3 || status_confirmed_id === 1"
        class="lessons__status-button"
        @click.stop="lessonStatusConfirm(2)"
      >
        <icon name="like" />
      </button>
      <button
        v-if="status_confirmed_id === 3 || status_confirmed_id === 2"
        class="lessons__status-button"
        @click.stop="lessonStatusConfirm(1)"
      >
        <icon name="dislike" />
      </button>
    </div>
    <!-- <div
      class="lessons__status-confirmed_user-name"
      v-if="status_confirmed_user !== '' && status_confirmed_id !== 3"
    >
      {{ status_confirmed_user }}
    </div> -->
  </div>
</template>

<script>
export default {
  props: {
    status_confirmed_id: {
      type: [Number, String]
    },
    lessonStatusId: {
      type: [Number, String]
    }
  },
  methods: {
    lessonStatusConfirm(confirm) {
      this.$emit('lessonStatusConfirm', confirm);
    }
  }
};
</script>

<style lang="scss" scoped>
.lessons__status-button {
  border: none;
  background: none;
}
.lessons__status-confirmed_user {
  display: flex;
  align-items: center;
  gap: 8px;
}
.lessons__status-confirmed_user-name {
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #38455d;
}
.lessons__status-confirmed_user-controls {
  display: flex;
  align-items: center;
  gap: 8px;
}
.lessons__status-button {
  width: 24px;
  height: 24px;
  cursor: pointer;
  display: flex;
  align-items: center;
}
</style>
